import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  required
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const rawNameRegex = /[ `!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/

const useStyles = makeStyles({
  inline: {
    display: 'inline-block',
    marginLeft: '1em',
    '&.first-child': {
      marginLeft: 0,
    },
  },
});

const QuizCreate = (props) => {
  const [translations, setTranslations] = React.useState([]);
  const classes = useStyles();

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/cms/translation-keys`)
      .then(res => res.json())
      .then(({data}) => {
        if (data && data.length) {
          setTranslations(data.map((item) => item.raw_name.toLocaleLowerCase()))
        }
      });
  }, []);

  const uniqueRawName = (value) => {
    if (translations.includes(value.toLocaleLowerCase())) {
      return 'Generic name must be unique'
    }

    if (rawNameRegex.test(value)) {
      return 'Generic name should not contain: \n`!@#$%^&*()+=\[\]{};\':"\\|,.<>\/?~'
    }

    return undefined
  }

  const rawNameValidator = [required(), uniqueRawName]

  return (
    <Create title="Add Pergunta" {...props}>
      <SimpleForm>
        <TextInput label="Nome genérico (pergunta)" source="raw_name" validate={rawNameValidator} />
        <TextInput label='Pontuação' placeholder='Caso não preenchido, o valor será 100' source='question_point'/>

        <TextInput label="Pergunta (pt-BR)" source="ptbr_name" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Pergunta (en-US)" source="enus_name" validate={required()} formClassName={classes.inline} />
        <TextInput label="Pergunta (es-ES)" source="es_name" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Pergunta (hu-HU)" source="hu_name" validate={required()} formClassName={classes.inline} /> */}
        <div></div>

        <ArrayInput source="options">
            <SimpleFormIterator >
              <BooleanInput label="Está correta" source="is_correct" defaultValue />
              <TextInput label="Nome genérico (option)" source="raw_name" validate={rawNameValidator} />
              <TextInput label="Pergunta (pt-BR)" source="ptbr_name" validate={required()} />
              <TextInput label="Pergunta (en-US)" source="enus_name" validate={required()} />
              <TextInput label="Pergunta (es-ES)" source="es_name" validate={required()} />
              {/* <TextInput label="Pergunta (hu-HU)" source="hu_name" validate={required()} /> */}
            </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
}

export default QuizCreate;
